// Deep imports keep these pure functions free of the UI kit (and its chart library).
import type { SortDirection } from '@src/packages/dashboard/components/ReportSummary/types';

import type { TaskDrilldown } from './types';

export const isUserDrilldown = (drilldown: TaskDrilldown) =>
  drilldown.kind === 'users' || drilldown.kind === 'userRange';

interface RankedTemplate {
  templateName: string;
  orders: number;
}

const byName = (a: RankedTemplate, b: RankedTemplate) =>
  a.templateName.localeCompare(b.templateName);

export const sortTemplatesByOrders = <T extends RankedTemplate>(templates: T[], direction: SortDirection) =>
  [...templates].sort((a, b) =>
    (direction === 'desc' ? b.orders - a.orders : a.orders - b.orders) || byName(a, b),
  );

export const sortTemplatesByCompliance = <T extends RankedTemplate & { completionRate: number }>(
  templates: T[],
  direction: SortDirection,
) =>
  [...templates].sort((a, b) =>
    (direction === 'asc'
      ? a.completionRate - b.completionRate
      : b.completionRate - a.completionRate) || byName(a, b),
  );
